import Onlynumber from "./onlynumber";
import Timer from "./timer";
import Placeholder from "./placeholder";
import placeholderInfo from "./placeholder-info";
import layerInfo from "./layer-info";
import Selection from './selection';
import animation from './animation';

let authPhone = new Onlynumber({
    el:"#auth-phone"
});

let authNumber = new Onlynumber({
    el:"#auth-number"
});

window.timerPreorder = new Timer({
    el:"#timer-preorder",
    minutes:5,
    start:false
});

window.placeholder = {};
$.each(placeholderInfo, (key, value)=>{
    placeholder[key] = new Placeholder({
        el:value
    });
});

window.selectBox = promokit.select({
    el:'#select-box',
    placeholder:"서버를 선택해 주세요.",
    options:[
        {value:1, label:'에리카'}
    ]
});

$.each(layerInfo, function(index, value){
    promokit.layer({
        el:value.el,
        buttons:value.btn,
    });
});

window.selection = new Selection({
    el:"#selection",
    data:{
        tribe:0,
        gender:0,
        job:212,
    },
    complete:false,
    callback(){
        if(this.targetEvent!=="tribe" || promokit.store('isMobile')) return;
        animation.character(this.curr.tribe);
    }
});

window.couponPeriod = true;
$(document).on('click', '.p-btn__coupon', function(e) {
    e.preventDefault();
    if(!couponPeriod){
        promokit.message({
            type: 'alert',
            message: '쿠폰등록 기간이 종료되었습니다.'
        });
        return;
    }
    promokit.coupon();
});

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
            `
        <h3>[공통]</h3>
        <ol>
            <li>본 이벤트에 제재 계정은 참여할 수 없습니다.</li>
            <li>본 이벤트는 각성 서버에 해당하며 본 서버는 적용되지 않습니다.</li>
            <li>데스나이트 캐릭터는 5. 26.(수) 이후 기존 각성 서버(바츠/지그하르트/카인/리오나)에서도 생성이 가능합니다.</li>
        </ol>
        <h3>[캐릭터 사전 생성]</h3>
        <ol>
            <li>본 이벤트는 각성 서버의 신규 서버 전용 이벤트입니다. 바츠/지그하르트/카인/리오나 서버는 적용되지 않습니다.</li>
            <li>신규 서버 캐릭터 사전 생성은 2021. 5. 20.(목) 17시 ~ 5. 23.(일) 23:59:59까지 생성할 수 있습니다.</li>
            <li>이벤트 페이지에서 사전 생성한 캐릭터는 2021. 5. 26.(수) 정기점검 이후 신규 서버에서 확인할 수 있습니다.</li>
            <li>캐릭터명 생성규칙은 게임에서의 캐릭터명 생성규칙과 동일하며, 동일한 캐릭터명의 중복 생성이 불가합니다.<br/>
               (한글 8자, 영문/숫자 16자까지 사용 가능, 두 글자 이상 입력, 한자/특수문자 사용 불가)</li> 
            <li>캐릭터 사전 생성은 사용 가능한 캐릭터명 확인 후 종족, 성별, 직업을 선택하여 계정당 1회 진행할 수 있습니다.</li>
            <li>캐릭터 사전 생성 완료 시 이벤트 페이지에서의 변경이 불가 합니다.</li>
            <li>캐릭터의 얼굴/머리모양/머리색상은 각 종족, 성별, 직업에 따라 기본 외형으로 일괄 적용됩니다.</li>
            <li>외형 변경은 서버 오픈 이후 NPC 상점을 통해 외형 변경 아이템을 구입하여 진행할 수 있습니다.</li>
        </ol>
        <h3>[캐릭터 사전 생성 특별 선물]</h3>
        <ol>
            <li>캐릭터 사전 생성 특별 선물은 캐릭터 사전 생성완료 후 [특별 선물 쿠폰 받기]를 통해 수령할 수 있습니다.</li>
            <li>특별 선물 쿠폰 받기는 2021. 6. 23.(수) 정기점검 전까지 가능합니다.</li>
            <li>지급된 쿠폰에 포함된 아이템은 2021. 5. 26.(수) 이후 신규 서버에서만 수령 가능합니다.</li>
            <li>지급된 쿠폰은 2021. 6. 23.(수)까지 사용 가능하며, 유효기간 종료 이후에는 복구 및 재지급이 불가합니다.</li>
            <li>데스나이트의 반지 아이템은 2021. 7. 21(수) 정기점검 시 일괄 삭제됩니다.</li>
        </ol>
        <h3>[업데이트 알림 등록 하기]</h3>
        <ol>
            <li>업데이트 알림 보상은 휴대폰 인증 후 받을 수 있습니다.</li>
            <li>해당 보상 아이템은 계정당 한 번, 휴대폰 번호당 한 번 등록 가능합니다.</li>
            <li>업데이트 알림 예약을 한 번 진행한 휴대폰 번호로는 재차 예약을 진행할 수 없습니다.</li>
            <li>보상 쿠폰 번호는 2021. 5. 26.(수) 입력하신 휴대폰 번호로 LMS 문자 발송됩니다.</li>
            <li>보상 쿠폰은 2021. 6. 23.(수)까지 사용 가능하며, 유효 기간 종료 이후에는 복구 및 재지급이 불가합니다.</li>
            <li>업데이트 알림 보상 아이템은 각성 서버에서 수령 가능 하며, 이중 "최상급 성장의 룬-30일 기간제" 아이템은 2021. 7. 21.(수) 정기점검 시 일괄 삭제 됩니다.</li>
        </ol>
        `
    }
});


// WEBPACK FOOTER //
// ./src/js/create/page.js